import type { IPaymentMethod } from '../data/paymentMethods'

export const getPaymentMethod = (id: number | null | undefined) => PAYMENT_METHODS.find((method) => method.id === id)

export const getPaymentMethodName = (method: IPaymentMethod, t: (key: string) => string) => (method.nameKey ? t(method.nameKey) : (method.name ?? ''))
